import { render, staticRenderFns } from "./AudienceCardFacebookDetails.vue?vue&type=template&id=078ef035"
import script from "./AudienceCardFacebookDetails.vue?vue&type=script&lang=js"
export * from "./AudienceCardFacebookDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports